import {
  Flex,
  Box,
  Text,
  Avatar,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  Tooltip,
  useDisclosure,
  ModalBody,
  Checkbox,
  Input,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Header from '../../../components/header/Header';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import useData from '../../../data/useData';
import moment from 'moment';
import Founders from './Founders';
import SearchBar from '../../../components/searchbar/SearchBar';
import UserExperts from '../../../pages/founder/Allusers/Experts';
import UserInvestors from '../../../pages/founder/Allusers/Investors';
import Users from './Users';
import RestrictedUsers from './RestrictedUsers';
import IsDesktop from '../../../utils/IsDesktop';
import { BsDownload } from 'react-icons/bs';
import client from '../../../libs/client';
import exportToCSV from '../../../utils/ExportToCSV';
import { BASE_URL } from '../../../helpers/constant';
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';

import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { useSelector } from 'react-redux';
import PermissionBlinder from '../../../components/PermissionBlinder';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
const { RangePicker } = DatePicker;

const AllUsers = () => {
  const navigate = useNavigate();
  const { data, refetch } = useData('user-statistics');
  const [userCount, setUserCount] = useState(data?.data?.totalUsers);
  const [blockedUserCount, setBlockedUserCount] = useState(
    data?.data?.totalBlockedUsers,
  );
  const [disabledUserCount, setDisabledUserCount] = useState(
    data?.data?.totalDisabledUsers,
  );
  const permissions = useSelector(
    (state) => state?.user?.userInfo?.permissions,
  );
  const [foundersCount, setFoundersCount] = useState(data?.data?.totalFounders);
  const [investorsCount, setInvestorsCount] = useState(
    data?.data?.totalInvestors,
  );
  const [expertsCount, setExpertsCount] = useState(data?.data?.totalExperts);
  const [lastTwoUsers, setLastTwoUsers] = useState(data?.data?.lastTwoUsers);
  const [lastTwoFounders, setLastTwoFounders] = useState(
    data?.data?.lastTwoFounders,
  );
  const [lastTwoExperts, setLastTwoExperts] = useState(
    data?.data?.lastTwoExperts,
  );
  const [lastTwoInvestors, setLastTwoInvestors] = useState(
    data?.data?.lastTwoInvestors,
  );
  const [lastTwoBlockedUsers, setLastTwoBlockedUsers] = useState(
    data?.data?.lastTwoBlockedUsers,
  );
  const [lastTwoDisabledUsers, setLastTwoDisabledUsers] = useState(
    data?.data?.lastTwoDisabledUsers,
  );
  const [displayedUserList, setDisplayedUserList] = useState('users');
  const [userSearchType, setUserSearchType] = useState('all');

  const [searchTerm, setSearchTerm] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: includeLiveUsers, onToggle: onToggleIncludeLiveUsers } =
    useDisclosure();
  const { isOpen: includeDraftUsers, onToggle: onToggleIncludeDraftUsers } =
    useDisclosure();
  const [from, setFrom] = useState(
    moment().startOf('month').format('YYYY-MM-DD'),
  );
  const [to, setTo] = useState(moment().add(1, 'day').format('YYYY-MM-DD'));
  const isDesktop = IsDesktop();

  useEffect(() => {
    if (data?.data) {
      setUserCount(data.data.totalUsers - 2);
      setFoundersCount(data.data.totalFounders);
      setInvestorsCount(data.data.totalInvestors);
      setExpertsCount(data.data.totalExperts);
      setBlockedUserCount(data?.data?.totalBlockedUsers);
      setDisabledUserCount(data?.data?.totalDisabledUsers);
      setLastTwoUsers(data.data.lastTwoUsers);
      setLastTwoFounders(data.data.lastTwoFounders);
      setLastTwoExperts(data.data.lastTwoExperts);
      setLastTwoInvestors(data.data.lastTwoInvestors);
      setLastTwoBlockedUsers(data?.data?.lastTwoBlockedUser);
      setLastTwoDisabledUsers(data?.data?.lastTwoDisabledUsers);
    } else {
      refetch();
    }
  }, [data, refetch]);

  const searchContext = {
    founders: 1,
    investors: 2,
    experts: 3,
    users: 'all',
    blocked: 'all',
    disabled: 'all',
  };

  const changeUserListView = (userType) => {
    setDisplayedUserList(userType);
    setUserSearchType(searchContext[userType]);
  };

  const onCalendarChange = (date) => {
    let dates = date.map((value) =>
      moment(value?.$d ? value['$d'] : moment()).format('YYYY-MM-DD'),
    );
    setFrom(
      moment(dates[0]).isAfter(moment().subtract(1, 'day'))
        ? moment().subtract(1, 'day').format('YYYY-MM-DD')
        : moment(dates[0]).format('YYYY-MM-DD'),
    );
    setTo(
      moment(dates[1]).isAfter(moment())
        ? moment().format('YYYY-MM-DD')
        : moment(dates[1]).format('YYYY-MM-DD'),
    );
  };

  const viewUser = (userId) => {
    navigate(`../admin/view-user?userid=${userId}`);
  };

  const downloadCSV = () => {
    const userTypes = `${includeDraftUsers ? ',draft' : ''}${includeLiveUsers ? ',live' : ''}`;
    return client()
      .get(
        `${BASE_URL}admins/export-user-data?from=${from}&to=${to}&category=${displayedUserList}${userTypes}`,
      )
      .then((res) => {
        onClose();
        const data = res.data.data.users;
        exportToCSV(data, 'seedafounder.csv', false);
      });
  };

  useEffect(() => {
    onToggleIncludeDraftUsers();
    onToggleIncludeLiveUsers();
  }, []);

  if (permissions && !permissions?.can_manage_users) {
    return <PermissionBlinder />;
  }

  return (
    <Box>
      <Header title={'Users'} />
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Export to CSV</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex className="mb-5 flex-col gap-5 items-center">
                <Flex className="w-full items-start flex-col gap-2">
                  <Text className="font-medium">Select Date Range</Text>
                  <Text className="text-sm">
                    Current Date Range: {from} to {to}
                  </Text>
                  <Text className="text-xs italic">
                    N/B: Date format is YYYY-MM-DD
                  </Text>
                </Flex>
                <Box>
                  <RangePicker
                    value={[dayjs(from), dayjs(to)]}
                    maxDate={dayjs()}
                    onCalendarChange={onCalendarChange}
                    format="YYYY-MM-DD"
                  />
                </Box>
                <Box className="w-full flex flex-col gap-2">
                  <Text className="font-medium">Users</Text>
                  <Box className="w-min flex-col flex gap-1">
                    <Checkbox
                      isChecked={includeDraftUsers}
                      onChange={() => {
                        onToggleIncludeDraftUsers();
                        if (!includeLiveUsers) onToggleIncludeLiveUsers();
                      }}
                      color="brand.primary"
                      borderColor="brand.primary"
                    >
                      Draft
                    </Checkbox>
                    <Checkbox
                      isChecked={includeLiveUsers}
                      onChange={() => {
                        onToggleIncludeLiveUsers();
                        if (!includeDraftUsers) onToggleIncludeDraftUsers();
                      }}
                      color="brand.primary"
                      borderColor="brand.primary"
                    >
                      Live
                    </Checkbox>
                  </Box>
                </Box>
                <ModalFooter>
                  <Button onClick={downloadCSV} colorScheme="blue">
                    Download CSV
                  </Button>
                </ModalFooter>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
      <Box
        className={`hide-scroll ${isDesktop ? 'max-h-[90vh] overflow-y-auto p-3' : ''} overflow-x-hidden px-3`}
      >
        <Box className="flex w-full justify-end px-5 py-2">
          <Tooltip label="Export as CSV">
            <Box
              onClick={onOpen}
              className="p-2 cursor-pointer max-h-9 border border-blue-100"
            >
              <BsDownload />
            </Box>
          </Tooltip>
        </Box>
        <Flex mt="3rem" mr="auto">
          <Box className="flex flex-wrap gap-4 w-full justify-center lg:justify-start items-center">
            <Box
              onClick={() => changeUserListView('users')}
              cursor="pointer"
              height="12.5rem"
              p={4}
              borderWidth="0.0625rem"
              borderRadius="1.25rem"
              boxShadow="lg"
              width="275px"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  boxShadow="lg"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="#134A70" style={{ marginLeft: '16px' }}>
                  All users
                </Text>
                {/* <BiDotsVerticalRounded /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoUsers?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {userCount ? `+${userCount}` : 0}
                </Box>
              </Flex>
              <Text
                mt="2.5rem"
                color="#134A70"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoUsers &&
                  `updated last  ${moment(lastTwoUsers[0]?.created_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>
            <Box
              cursor="pointer"
              onClick={() => changeUserListView('founders')}
              width="275px"
              height="12.5rem"
              p={4}
              borderWidth="0.0625rem"
              borderRadius="1.25rem"
              boxShadow="lg"
              overflow="hidden"
              bg="#F10D35"
              box-shadow=".25rem 1.25rem 2.5rem rgba(232, 83, 62, 0.2)"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="white" style={{ marginLeft: '16px' }}>
                  Founders
                </Text>
                {/* <BiDotsVerticalRounded color="white" /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoFounders?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {foundersCount ? `+${foundersCount}` : 0}
                </Box>
              </Flex>

              <Text
                mt="2.5rem"
                color="white"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoFounders &&
                  `updated last  ${moment(lastTwoFounders[0]?.created_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>

            <Box
              cursor="pointer"
              onClick={() => changeUserListView('experts')}
              width="275px"
              height="12.5rem"
              p={4}
              borderWidth="0.063rem"
              borderRadius="1.25rem"
              overflow="hidden"
              boxShadow="lg"
              bg="#134A70"
              box-shadow="1.25rem 1.25rem 2.5rem rgba(232, 83, 62, 0.2)"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="white" style={{ marginLeft: '16px' }}>
                  Experts
                </Text>
                {/* <BiDotsVerticalRounded color="white" /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoExperts?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {expertsCount ? `+${expertsCount}` : 0}
                </Box>
              </Flex>

              <Text
                mt="2.5rem"
                color="white"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoExperts &&
                  `updated last ${moment(lastTwoExperts[0]?.created_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>

            <Box
              cursor="pointer"
              onClick={() => changeUserListView('investors')}
              width="275px"
              height="12.5rem"
              p={4}
              borderWidth="0.063rem"
              borderRadius="1.25rem"
              overflow="hidden"
              boxShadow="lg"
              bg="#F8B748"
              box-shadow="1.25rem 1.25rem 2.5rem rgba(232, 83, 62, 0.2)"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="white" style={{ marginLeft: '16px' }}>
                  Investors
                </Text>
                {/* <BiDotsVerticalRounded color="white" /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoInvestors?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {investorsCount ? `+${investorsCount}` : 0}
                </Box>
              </Flex>

              <Text
                mt="2.5rem"
                color="white"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoInvestors &&
                  `updated last ${moment(lastTwoInvestors[0]?.created_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>

            <Box
              className="bg-blue-400"
              cursor="pointer"
              onClick={() => changeUserListView('disabled')}
              width="275px"
              height="12.5rem"
              p={4}
              borderWidth="0.063rem"
              borderRadius="1.25rem"
              overflow="hidden"
              boxShadow="lg"
              box-shadow="1.25rem 1.25rem 2.5rem rgba(232, 83, 62, 0.2)"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="white" style={{ marginLeft: '16px' }}>
                  Disabled
                </Text>
                {/* <BiDotsVerticalRounded color="white" /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoDisabledUsers?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {disabledUserCount ? `+${disabledUserCount}` : 0}
                </Box>
              </Flex>

              <Text
                mt="2.5rem"
                color="white"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoDisabledUsers &&
                  `updated last ${moment(lastTwoDisabledUsers[0]?.updated_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>

            <Box
              className="bg-purple-400"
              cursor="pointer"
              onClick={() => changeUserListView('blocked')}
              width="275px"
              height="12.5rem"
              p={4}
              borderWidth="0.063rem"
              borderRadius="1.25rem"
              overflow="hidden"
              boxShadow="lg"
              box-shadow="1.25rem 1.25rem 2.5rem rgba(232, 83, 62, 0.2)"
            >
              <Flex justify="start">
                <Box
                  bg="#fff"
                  w="1.563rem"
                  borderRadius="0.188rem"
                  pl="0.063rem"
                  borderWidth="0.188rem"
                >
                  <HiOutlineUserGroup />
                </Box>
                <Text color="white" style={{ marginLeft: '16px' }}>
                  Blocked
                </Text>
                {/* <BiDotsVerticalRounded color="white" /> */}
              </Flex>
              <Flex mt="1.875rem">
                {lastTwoBlockedUsers?.map((each, index) => (
                  <Box>
                    <Avatar
                      name={`${each?.first_name} ${each?.last_name}`}
                      src={each?.profile_image}
                      zIndex={index}
                      ml={-2}
                    />
                  </Box>
                ))}
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="brand.primary"
                  w="50px"
                  h="50px"
                  fontWeight="25rem"
                  borderRadius="50%"
                  p="0.188rem"
                  boxShadow="lg"
                  zindex="3"
                  ml="-0.563rem"
                  color="white"
                >
                  {blockedUserCount ? `+${blockedUserCount}` : 0}
                </Box>
              </Flex>

              <Text
                mt="2.5rem"
                color="white"
                fontWeight="25rem"
                fontFamily="Poppins"
                fontSize="0.75rem"
              >
                {lastTwoBlockedUsers &&
                  `updated last ${moment(lastTwoBlockedUsers[0]?.updated_at).format('DD/MM/YYYY')}`}
              </Text>
            </Box>
          </Box>
        </Flex>
        <Flex w="100%">
          <Box mt="20px" w="100%">
            <Flex
              w="100%"
              justify="space-between"
              alignItems="center"
              gap={4}
              flexWrap="wrap"
            >
              <Input
                placeholder="Search by name..."
                size="md"
                onChange={(e) => setSearchTerm(e.target.value)}
                flexGrow={1}
                maxWidth={{ base: '100%', md: '356px' }}
              />
              <Flex gap={2} alignItems="center" flexWrap="wrap">
                <Button
                  bg={
                    displayedUserList === 'users' ? 'brand.primary' : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'users' ? '#FFFFFF' : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  boxShadow="base"
                  borderRadius="0px"
                  onClick={() => changeUserListView('users')}
                >
                  All
                </Button>
                <Button
                  bg={
                    displayedUserList === 'founders'
                      ? 'brand.primary'
                      : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'founders'
                      ? '#FFFFFF'
                      : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  boxShadow="base"
                  borderRadius="0px"
                  onClick={() => changeUserListView('founders')}
                >
                  Founders
                </Button>
                <Button
                  bg={
                    displayedUserList === 'experts'
                      ? 'brand.primary'
                      : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'experts'
                      ? '#FFFFFF'
                      : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  borderRadius="5px 0px 0px 5px"
                  boxShadow="base"
                  onClick={() => changeUserListView('experts')}
                >
                  Experts
                </Button>
                <Button
                  bg={
                    displayedUserList === 'investors'
                      ? 'brand.primary'
                      : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'investors'
                      ? '#FFFFFF'
                      : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  boxShadow="base"
                  borderRadius="0px 5px 5px 0px"
                  onClick={() => changeUserListView('investors')}
                >
                  Investors
                </Button>
                <Button
                  bg={
                    displayedUserList === 'disabled'
                      ? 'brand.primary'
                      : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'disabled'
                      ? '#FFFFFF'
                      : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  boxShadow="base"
                  borderRadius="0px 5px 5px 0px"
                  onClick={() => changeUserListView('disabled')}
                >
                  Disabled
                </Button>
                <Button
                  bg={
                    displayedUserList === 'blocked'
                      ? 'brand.primary'
                      : '#FFFFFF'
                  }
                  color={
                    displayedUserList === 'blocked'
                      ? '#FFFFFF'
                      : 'brand.primary'
                  }
                  _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                  boxShadow="base"
                  borderRadius="0px 5px 5px 0px"
                  onClick={() => changeUserListView('blocked')}
                >
                  Blocked
                </Button>
              </Flex>
            </Flex>
          </Box>
        </Flex>
        <Box
          className={`${isDesktop ? 'max-w-[75vw] xl:max-w-[83vw]' : 'max-w-98vw'} overflow-x-auto hide-scroll`}
        >
          {displayedUserList === 'users' && (
            <Users viewUser={viewUser} searchTerm={searchTerm} />
          )}
          {displayedUserList === 'founders' && (
            <Founders viewUser={viewUser} searchTerm={searchTerm} />
          )}
          {displayedUserList === 'experts' && (
            <UserExperts viewUser={viewUser} searchTerm={searchTerm} />
          )}
          {displayedUserList === 'investors' && (
            <UserInvestors viewUser={viewUser} searchTerm={searchTerm} />
          )}
          {displayedUserList === 'disabled' && (
            <RestrictedUsers
              type="disabled"
              viewUser={viewUser}
              searchTerm={searchTerm}
            />
          )}
          {displayedUserList === 'blocked' && (
            <RestrictedUsers viewUser={viewUser} searchTerm={searchTerm} />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default AllUsers;
